import { GameConstants } from "./../../../GameConstants";
import { GameVars } from "../../../GameVars";
import * as Carrom from "carrom-king-engine";
import { BootScene } from "../../BootScene";

export class MessageContainer extends Phaser.GameObjects.Container {

    private messageBackground: Phaser.GameObjects.Graphics;
    private messageLabel: Phaser.GameObjects.Text;

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.y = GameConstants.GAME_HEIGHT / GameVars.scaleY - 60;

        const w = 375;
        const h = 50;

        this.visible = false;

        this.messageBackground = new Phaser.GameObjects.Graphics(this.scene);
        this.messageBackground.fillStyle(0x132A4B, .85);
        this.messageBackground.fillRoundedRect(-w / 2, -h / 2, w, h, 15);
        this.add(this.messageBackground);

        this.messageLabel = new Phaser.GameObjects.Text(this.scene, 0, 0 + (BootScene.textYgap * -50), "", { fontFamily: "Arial", fontStyle: "bold", align: "center", fontSize: "26px", color: "#FFFFFF" });
        this.messageLabel.setOrigin(.5, BootScene.originY);
        this.add(this.messageLabel);
    }

    public showMessage(type?: string): void {

        if (type) {

            const gameText = this.scene.game.cache.json.get("game-text");

            this.visible = true;
            this.messageLabel.text = gameText.CLOCK_TICKING;
            this.setMessageBackground();

            if (this.visible) {
                this.scene.time.addEvent({
                    delay: 2500,
                    callback: function (): void {
                        this.visible = false;
                    },
                    callbackScope: this
                });
            }
            return;
        }

        const gameText = this.scene.game.cache.json.get("game-text");

        if (GameVars.turnData) {

            if (GameVars.currentTurnPlayerId !== GameVars.playerData.id) {
                if (GameVars.turnData.faults.indexOf(Carrom.Fault.QUEEN_NOT_COVERED) !== -1) {
                    this.visible = true;
                    this.messageLabel.text = gameText.QUEEN_NOT_COVERED;
                    this.setMessageBackground();
                } else if (GameVars.turnData.faults.indexOf(Carrom.Fault.LAST_PUCK_POCKETED) !== -1 || GameVars.turnData.faults.indexOf(Carrom.Fault.LAST_ADVERSARY_PUCK_POCKETED) !== -1) {
                    if (GameVars.gameMode === Carrom.GameMode.PROFESSIONAL) {
                        this.visible = true;
                        this.messageLabel.text = gameText.LAST_PUCK_POCKETED;
                        this.setMessageBackground();
                    }
                } else if (GameVars.turnData.faults.indexOf(Carrom.Fault.NO_PUCK_POCKETED) !== -1 || GameVars.turnData.faults.indexOf(Carrom.Fault.ADVERSARY_PUCK_POCKETED) !== -1) {
                    if (GameVars.gameMode === Carrom.GameMode.PROFESSIONAL) {
                        this.visible = true;
                        this.messageLabel.text = gameText.POT_ALL_PUCKS.replace("*", GameVars.playerColor || "white");
                        this.setMessageBackground();
                    }
                }
            }

            if (GameVars.turnData.hasQueenBeenPocketed && GameVars.currentTurnPlayerId === GameVars.playerData.id && !GameVars.turnData.skipQueenCovering && GameVars.turnData.faults.length === 0) {
                this.visible = true;
                this.messageLabel.text = gameText.QUEEN_POCKETED;
                this.setMessageBackground();
            }
        }

        if (this.visible) {
            this.scene.time.addEvent({
                delay: 2500,
                callback: function (): void {
                    this.visible = false;
                },
                callbackScope: this
            });
        }
    }

    public showDisconnectionMessage(): void {

        this.visible = true;
        this.messageLabel.text = "Network disconnection.\nTrying to reconnect...";
        this.setMessageBackground(80);
    }

    public hideDisconnectionMessage(): void {

        this.visible = false;
    }

    private setMessageBackground(height?: number): void {

        let w = this.messageLabel.width + 20;

        height = height || 50;

        this.messageBackground.clear();
        this.messageBackground.fillStyle(0x132A4B, .85);
        this.messageBackground.fillRoundedRect(-w / 2, -height / 2, w, height, 15);
    }

}
